import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class CommuniqueService {
  dialogData: any = {};
  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {}

  actionCall(actionName: string, selectedData: any): any {
    if (!selectedData || !selectedData.length) {
      let errorMsg = this.translate.instant('communique.select_comnq_alert');
      this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
    } else if (selectedData.length > 1) {
      let errorMsg = this.translate.instant('communique.select_one_alert');
      this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
    } else {
      console.log(
        'we have selected communique dataaaaaaaaaaaaaaaa',
        actionName
      );
      if (actionName === 'CloseCommunique') {
        let postData = {
          instNo: [Number(selectedData.instNo)],
          status: '144',
          lstUpdtPost: selectedData.instFromPostId,
        };
        this.closeCommunique(postData).subscribe(
          (res) => {
            //this.dialogRef.close(true);
          },
          (error) => {
            //this.dialogRef.close(false);
          }
        );
      }
    }
  }

  public closeCommunique(data): Observable<any> {
    let url = '/worklist/close-communique';
    return this.http.post(url, data);
  }
  public deleteCommunique(data): Observable<any> {
    let url = '/worklist/delete-communique';
    return this.http.post(url, data);
  }
  public replyOrForwardCommunique(data): Observable<any> {
    let url = '/worklist/replyorforward-communique';
    return this.http.post(url, data);
  }
  public trackCommunique(data): Observable<any> {
    let url = '/worklist/track-communique';
    return this.http.post(url, data);
  }
}
